import { render } from "./Edit.vue?vue&type=template&id=b8ec81c4"
const script = {}
script.render = render

export default script